import { axios } from '@vyce/core/src/api';

import { SendDocumentRequest } from '../types';
import config from '../config';
import { ScheduledNotification } from '../../types';

const URL = `${config.gatewayApiUrl}`;

export const createScheduledNotificationRequest = ({
  companyId,
  scheduledNotification,
}: {
  companyId: string;
  scheduledNotification: ScheduledNotification;
}) => {
  return axios.post(
    `${URL}/public/v1/notifications/companies/${companyId}/scheduled/daily-time-update`,
    scheduledNotification
  );
};

export const updateScheduledNotificationRequest = ({
  companyId,
  scheduledNotification,
  scheduledNotificationId,
}: {
  companyId: string;
  scheduledNotification: ScheduledNotification;
  scheduledNotificationId: string;
}) => {
  return axios.post(
    `${URL}/public/v1/notifications/companies/${companyId}/scheduled/${scheduledNotificationId}`,
    scheduledNotification
  );
};

export const getScheduledNotificationsRequest = ({ companyId }: { companyId: string }) => {
  return axios.get(`${URL}/public/v1/notifications/companies/${companyId}/scheduled`);
};

export const deleteScheduledNotificationsRequest = ({
  companyId,
  scheduledNotificationId,
}: {
  companyId: string;
  scheduledNotificationId: string;
}) => {
  return axios.delete(
    `${URL}/public/v1/notifications/companies/${companyId}/scheduled/${scheduledNotificationId}`
  );
};

export const restoreScheduledNotificationsRequest = ({
  companyId,
  scheduledNotificationId,
}: {
  companyId: string;
  scheduledNotificationId: string;
}) => {
  return axios.post(
    `${URL}/public/v1/notifications/companies/${companyId}/scheduled/${scheduledNotificationId}/restore`
  );
};

export const sendPassportRequest = ({ token, companyId, userId }: SendDocumentRequest) => {
  return axios.post(`/notifications/companies/${companyId}/users/${userId}/share_passport_email`);
};

export const sendShareCodeRequest = ({ token, companyId, userId }: SendDocumentRequest) => {
  return axios.post(`/notifications/companies/${companyId}/users/${userId}/share_code_email`);
};

export const getEmailUnsubscriptionGroupsRequest = () => {
  return axios.get(`/notifications/unsubscribe/groups`);
};

export const subscribeRequest = ({ token, groups }: { token: string; groups: string[] }) => {
  return axios.delete(`/notifications/unsubscribe`, {
    data: { groups },
  });
};

export const unsubscribeRequest = ({ token, groups }: { token: string; groups: string[] }) => {
  return axios.post(`/notifications/unsubscribe`, { groups });
};
